import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10.008, height: 7.39, viewBox: "0 0 10.008 7.39", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Dreieck_545", "data-name": "Dreieck 545", d: "M1346.328,4151.949a1,1,0,0,1-1.656,0l-4-5.389a1,1,0,0,1,.828-1.561h8a1,1,0,0,1,.828,1.561Z", transform: "translate(-1340.496 -4144.999)", fill: "currentColor" }));
export { SvgArrow as ReactComponent };

export { default } from "./arrow.svg?url"
